module.exports = __webpack_public_path__ + "img/bad.ea7292cf.png";